window.c24DomReady(function() {

    const trackingEvents = [
        {
            selector: '.div24Sea.studenten .mod24ac .button .c24Button',
            category: 'LandingPages',
            actionName: 'lp_br_student_stickybutton_clicked',
        },
        {
            selector: '.div24Sea.studenten .mod24Flat article.weg .c24Button',
            category: 'LandingPages',
            actionName: 'lp_br_student_phv_clicked',
        },
        {
            selector: '.div24Sea.studenten .mod24Flat article.wg .c24Button',
            category: 'LandingPages',
            actionName: 'lp_br_student_hr_clicked',
        },
        {
            selector: '.div24Sea.studenten .mod24Flat article.job .c24Button',
            category: 'LandingPages',
            actionName: 'lp_br_student_bu_clicked',
        },
        {
            selector: '.div24Sea.studenten .c24-ekomi a',
            category: 'LandingPages',
            actionName: 'lp_br_student_ekomi_clicked',
        },
        {
            selector: '.mod24ac.bp .widgetWrapper .c24Button',
            category: () => window.c24Lp.getMatomoEventCategory(),
            actionName: 'landing_page_vc_vplus',
            eventName: 'lp_mainCTA_clicked',
        },
        {
            selector: '.siegelHighlight a',
            category: () => window.c24Lp.getMatomoEventCategory(),
            actionName: 'landing_page_vc_vplus',
            eventName: 'lp_gototest_clicked',
        },
    ];


    for (const tracking of trackingEvents) {
        if (tracking.selector.includes('.div24Sea.studenten') && !document.querySelector('.div24Sea.studenten')) {
            continue;
        }

        const elements = document.querySelectorAll(tracking.selector);

        for (const elem of elements) {

            elem.addEventListener('click', function() {

                const category = typeof tracking.category === 'function' ? tracking.category() : tracking.category;

                const eventData = [
                    'trackEvent',
                    category,
                    tracking.actionName,
                ];

                if (tracking.eventName) {
                    eventData.push(tracking.eventName);
                }

                window._paq.push(eventData);
            });
        }
    }

});
